import React from 'react';
import { CarruselLeft, CarruselRight } from 'src/assets/Images';
import { PaginationContainer, ChangePageButton } from '../styles';
function Pagination(_a) {
    var totalPages = _a.totalPages, currentPage = _a.currentPage, onPageChange = _a.onPageChange;
    return (React.createElement(PaginationContainer, null,
        React.createElement(ChangePageButton, { onClick: function () { return currentPage > 1 && onPageChange(currentPage - 1); }, style: {
                opacity: currentPage > 1 ? '100%' : 0,
                cursor: currentPage > 1 ? 'pointer' : 'auto',
            } },
            React.createElement("img", { src: CarruselLeft, alt: "Flecha hacia la izquierda" })),
        currentPage,
        "/",
        totalPages || 1,
        React.createElement(ChangePageButton, { onClick: function () {
                return currentPage < totalPages && onPageChange(currentPage + 1);
            }, style: {
                opacity: currentPage < totalPages ? '100%' : 0,
                cursor: currentPage < totalPages ? 'pointer' : 'auto',
            } },
            React.createElement("img", { src: CarruselRight, alt: "Flecha hacia la derecha" }))));
}
export default Pagination;
